<template>
  <v-data-table
    :headers="headers"
    :items="optionHoldings"
    :no-data-text="loadingOrNoDataText"
    hide-default-footer
  >
    <template #item.dateOfIssue="{ item }">
      {{ (new Date(item.dateOfIssue)).toLocaleDateString('en-AU') }}
    </template>
  </v-data-table>
</template>

<script>
export default {
  Name: 'OptionsTable',
  props: {
    optionHoldings: { type: Array, required: true },
    loadingOrNoDataText: { type: String, default: 'No Data' }
  },
  data: function () {
    return {
      headers: [
        { text: 'Optionholder', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Address', value: 'address' },
        { text: 'No. Issued Shares', value: 'numberOfShares' },
        { text: 'Strike Price', value: 'strikePrice' },
        { text: 'Valuation', value: 'relevantValuation' },
        { text: 'Type', value: 'shareTypeClass' },
        { text: 'Vesting Conditions', value: 'vestingConditions' },
        { text: 'Notes', value: 'otherNotes' },
        { text: 'Date of issue', value: 'dateOfIssue' }
      ]
    }
  }
}
</script>

<style>

</style>
